import {useAuth0} from '@auth0/auth0-react';
import {useCallback} from 'react';

const useOidcFetch = () : typeof fetch => {
    const {getAccessTokenSilently, loginWithRedirect} = useAuth0();

    return useCallback(async (input : RequestInfo | URL, init ?: RequestInit) => {
        let accessToken;

        try {
            accessToken = await getAccessTokenSilently();
        } catch (error) {
            void loginWithRedirect();
            throw error;
        }

        if (!init) {
            init = {};
        }

        init.headers = new Headers(init.headers);
        init.headers.set('Authorization', `Bearer ${accessToken}`);

        return await fetch(input as Request | string, init);
    }, [getAccessTokenSilently, loginWithRedirect]);
};

export default useOidcFetch;
